import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { Icon } from '@iconify/react';
import { Button, Chip } from '@nextui-org/react';
import { DashboardTab } from '../../../services/tenant-config-service';

interface Props {
  tab: DashboardTab;
  onDelete: () => void;
  onToggle: () => void;
  onEdit: () => void;
}

export function SortableTabItem({ tab, onDelete, onToggle, onEdit }: Props) {
  // Check if this is a default tab
  const isDefaultTab = tab?.id?.startsWith('default-');
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: tab.id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
  };

  return (
    <div
      ref={setNodeRef}
      style={style}
      className="flex items-center justify-between p-3 bg-default-50 rounded-lg"
    >
      <div className="flex items-center gap-4">
        <div
          {...(isDefaultTab ? {} : attributes)}
          {...(isDefaultTab ? {} : listeners)}
          className="cursor-move p-1 hover:bg-default-100 rounded"
        >
          <Icon icon="heroicons:bars-3" className="w-5 h-5" />
        </div>

        <div className="flex items-center gap-2">
          <span className="text-xs font-medium text-default-600">
            #{tab.priority}
          </span>
          <span className="font-medium">{tab.label}</span>
          <Chip size="sm" variant="flat" color="secondary" className="ml-2">
            {tab.tag}
          </Chip>
        </div>
      </div>

      <div className="flex items-center gap-2">
        <Chip
          size="sm"
          variant="dot"
          color={tab.is_active ? 'success' : 'default'}
          className={isDefaultTab ? undefined : 'cursor-pointer'}
          onClick={onToggle}
        >
          {tab.is_active ? 'Active' : 'Inactive'}
        </Chip>
        {!isDefaultTab && (
          <div className="flex gap-2">
            <Button isIconOnly size="sm" variant="light" onClick={onEdit}>
              <Icon icon="heroicons:pencil" className="w-4 h-4" />
            </Button>
            <Button
              isIconOnly
              size="sm"
              variant="light"
              color="danger"
              onClick={onDelete}
            >
              <Icon icon="heroicons:trash" className="w-4 h-4" />
            </Button>
          </div>
        )}
      </div>
    </div>
  );
}
